export const VERIFY_ROUTE = 'VERIFY_ROUTE';
export const VERIFY_ROUTE_SUCCESS = 'VERIFY_ROUTE_SUCCESS';
export const LOAD_PHOTO = 'LOAD_PHOTO';
export const LOAD_PHOTO_SUCCESS = 'LOAD_PHOTO_SUCCESS';
